export function inputStringToFloat(value: string): number {
  const negativeCorrectedValue = value.replace('\u2212', '\u002d');
  const parsedValue = parseFloat(negativeCorrectedValue);
  return isNaN(parsedValue) ? 0 : parsedValue;
}
